import { getFromLocal } from "src/util/cache.service";
import { LOCAL_KEYS, USER_ROLE } from "src/util/util.constant";

interface UserDetail {
  role?: string | string[];
  roles?: string | string[];
  userRole?: { name?: string };
  user?: { role?: string | string[]; roles?: string | string[] };
}

export const canViewVehicleStateCounter = () => {
  const role = getFromLocal<string>(LOCAL_KEYS.ROLE, false, true);
  const detail = getFromLocal<UserDetail>(LOCAL_KEYS.USER_DETAIL, true, true);
  const normalize = (value: string) => value.toLowerCase().replace(/[\s_-]/g, "");
  const allowed = [USER_ROLE.SuperUser, USER_ROLE.RootrUser].map(normalize);
  return [role, detail?.role, detail?.roles, detail?.userRole?.name, detail?.user?.role, detail?.user?.roles]
    .flat().some((value) => typeof value === "string" && allowed.includes(normalize(value)));
};

